<template>
  <v-row  dense>
    <v-col cols="12">
      <bar-time-mode ></bar-time-mode>
    </v-col>

    <v-col cols="12" v-if="isAsSoonAsPosible" class="mt-1">
      <schedule-as-soon-as-posible v-model="deliveryTime"></schedule-as-soon-as-posible>
    </v-col>

    <v-col cols="12" v-if="isScheduled" class="mt-2">
      <v-row >
        <v-col cols="12" md="6">
          <date-input outlined prepend-icon="" dense hide-details
                      prepend-inner-icon="date_range"
                      label="fecha"
                      v-model="deliveryDate"
                      :allowed-dates="allowedDates"
                      :clearable="false"
          >
            <template v-slot:prepend-inner>
              <v-icon :color="colorAccordingToDate">date_range</v-icon>
            </template>
          </date-input>
        </v-col>
        <v-col cols="12" md="6">
          <schedule-time-combobox v-model="deliveryTime" hide-details dense></schedule-time-combobox>
        </v-col>
      </v-row>


    </v-col>


  </v-row>
</template>

<script>
import ScheduleTimeCombobox
  from "@/modules/delivery/components-core/shared/ScheduleTimeCombobox/ScheduleTimeCombobox.vue";
import ScheduleAsSoonAsPosible
  from "@/modules/delivery/components-core/shared/ScheduleAsSoonAsPosible/ScheduleAsSoonAsPosible.vue";
import BarTimeMode from "@/modules/delivery/components-core/business/BarTimeMode/BarTimeMode.vue";
import {DateInput, Dayjs} from "@dracul/dayjs-frontend";

export default {
  name: "BarOrderModeTakeAway",
  components: {BarTimeMode, ScheduleAsSoonAsPosible, ScheduleTimeCombobox, DateInput},
  methods: {
    allowedDates(value) {
      if(Dayjs(value).isBefore(Dayjs().startOf('day'))){
        return false
      }else if(Dayjs(value).isAfter(Dayjs().add(10,'days').startOf('day'))){
        return false
      }
      return true
    }
  },
  computed: {
    colorAccordingToDate(){
      if(Dayjs().isBefore(this.deliveryDate)){
        return "purple"
      }else{
        return "grey"
      }
    },
    isCalendarActive() {
      return this.$store.state.orderStore.orderSystem.isCalendarTakeAwayActive()
    },
    isScheduled() {
      return this.$store.getters.orderSystem.order.isScheduled
    },
    isAsSoonAsPosible() {
      return this.$store.getters.orderSystem.order.isAsSoonAsPossible
    },
    deliveryTime: {
      get() {
        return this.$store.getters.deliveryTime;
      },
      set(value) {
        this.$store.commit("orderTime", value);
      }
    },
    deliveryDate: {
      get() {
        return this.$store.getters.deliveryDate;
      },
      set(value) {
        this.$store.commit("orderDate", value);
      }
    }
  }
}
</script>

<style scoped>

</style>
